import React from "react";

const CallToAction = () => {
  return (
    <section className="revamp-cta">
        <div className="container">
            <div className="revamp-cta__inner">
                <div className="row align-items-center">
                    <div className="col-xl-7 col-12 text-center text-xl-start">
                        <h2>Ready To Get Free Consultations For Any Kind Of IT Solutions?</h2>
                    </div>
                    <div className="col-xl-5 col-12 text-center text-xl-end" style={{marginTop: '20px'}}>
                        <a href="/contact" className="revamp-btn revamp-btn--white">
                            Get a quote <i className="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default CallToAction;